import { HomeComponentProps, HomeComponentState, HomeComponentHandler } from './homecomponent';
import { HomeCSSStyle } from './homecss';
import { UIComponentHandler } from '../../../toolkit/uicomponent';
import * as React from 'react';
import { FeaturedCategoryDto } from '../../../../core/dto/featuredcategory/featuredcategorydto';
import { BaseContext } from '../../../../utils/basecontext';
import { CRBTUIViewImpl } from '../crbt/crbtuiview';
import { BannerComponent } from '../banner/bannercomponent';
import { BannerDto } from '../../../../core/dto/banner/bannerdto';
import { Strings } from '../../../../utils/resources/strings';
import { FeaturedCategoryComponent } from '../featuredcategory/featuredcomponent';
import { SearchBoxComponent } from '../../../toolkit/toolbarwithsearch/searchbox/searchboxcomponent';
import { SearchBoxCSSStyle, SearchBoxCSSStyleImpl } from '../../../toolkit/toolbarwithsearch/searchbox/searchboxcss';
import { SearchBoxToneOptionComponent } from '../../../toolkit/toolbarwithsearch/searchbox/searchboxtoneoption/searchboxtoneoptioncomponent';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';
import './home-style.css';
import '../crbt/crbt-style.css';
import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';

export class HomeViewImpl extends CRBTUIViewImpl
{ 
    private searchCSSStyle:SearchBoxCSSStyle;
    // private featuredCategroiesRefMap: Map<string, FeaturedCategoryListComponent>;
    constructor(context: BaseContext, uiComponentHandler: UIComponentHandler)
    {
        super(context, uiComponentHandler);

        this.searchCSSStyle = new SearchBoxCSSStyleImpl(context);
        // this.featuredCategroiesRefMap = new Map();
    }

    bindHandlers()
    {
        this.onBannerClick = this.onBannerClick.bind(this);
        // this.onCategorySelected = this.onCategorySelected.bind(this);
        // this.onKeyPressEvent = this.onKeyPressEvent.bind(this);
        this.onLoadMore = this.onLoadMore.bind(this);
        this.onSearchButtonClick = this.onSearchButtonClick.bind(this);
        this.onSpecificSearchClick = this.onSpecificSearchClick.bind(this);

    }

    // draw(props: HomeComponentProps, state: HomeComponentState, cssStyle: HomeCSSStyle): JSX.Element | boolean
    // {
    //     super.draw(props, state, cssStyle);

    //     return (
    //         <div style={cssStyle.getWrapperCSSStyle()}>
    //               {
    //                    state.listOfFeaturedCategories.map((featuredCategoryDto: FeaturedCategoryDto, index: number) =>
    //                    {
    //                       return <FeaturedCategoryListComponent  ref={(item: FeaturedCategoryListComponent) => {this.featuredCategroiesRefMap.set(featuredCategoryDto.getTitle(), item);}} onLoadMore={this.onLoadMore}  key={index} featuredCategory={featuredCategoryDto}   context={props.context}/>;
    //                    })
    //               }
    //               {
    //                   state.listOfCategories.length > 0 && 
    //                    <CategoriesComponent   onCategorySelected={this.onCategorySelected}   listOfDatas={state.listOfCategories}  context={props.context}/>
    //               }
    //         </div>
    //     );
    // }

    draw(props: HomeComponentProps, state: HomeComponentState, cssStyle: HomeCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <>
            
                <div id="home-wrapper">
                    {
                        this.getWebView(props, state, cssStyle)
                    }
                </div>
                {/* <div id="home-mobile-wrapper">
                    {
                        this.getMobileView(props, state, cssStyle)
                    }
                </div> */}
            </>);
    }

    getWebView(props: HomeComponentProps, state: HomeComponentState, cssStyle: HomeCSSStyle):JSX.Element
    {
        return(
            <>
                    {/* <img  style={cssStyle.getLogoCSSStyle()} src={this.getUIProps().context.getResources().getImage(".svg")}/> */}
                       <>
                          <div id="mpt-banner-web">
                              {
                                  this.getMPTBannerWeb(cssStyle)
                              }
                          </div>
                          <div id="mpt-banner-mobile">
                              {
                                  this.getMPTBannerMobile(cssStyle)
                              }
                          </div>
                       </>
                       {
                           state.isConfiguartionLoaded && state.listOfBannerDtos.length > 0 && 
                            <BannerComponent onBannerClick={this.onBannerClick} listOfBannerDto={state.listOfBannerDtos} context={props.context}/>
                       }
                       <div id="home-search-main" style={{backgroundImage: "url('" + this.getContext().getResources().getImage("search_bg.svg") + "')",}}>
                       <div  id="home-search-div" style={{}}>
   
                               <SearchBoxToneOptionComponent type={props.context.getResources().getString(Strings.song)} context={this.getContext()} searchKey={""} onSearchBoxButtonClicked={this.onSpecificSearchClick}/>
                      </div>
                      </div>    
                      {state.isConfiguartionLoaded && 
                       <div id="crbt-home-inner-wrapper" style={cssStyle.getInnerCSSStyle()}>
                            <FeaturedCategoryComponent context={props.context}/>
                       </div>
                      }
                       {/* <div id="home-search-box-wrapper" style={{width:'100%', height:'300px',marginTop:'25px',display: "flex", flexFlow: "row wrap",backgroundImage: "url('" + this.getContext().getResources().getImage("nametunes.jpg") + "')",backgroundSize: "cover",}}>
                           
                           <label id="home-search-greet-label" style={{width:'100%',paddingLeft:'75px',paddingTop:'80px', height:'30px', lineHeight:'30px',fontSize:'40px',color:'#FFCD00',textAlign:'left'}}>
                               {this.getContext().getResources().getString(Strings.greet_caller_with_your_name_tunes)}
                           </label>
                           <div id="search-box-main-div" style={{marginTop:'0px',width:'60%',height:'50px',marginLeft:'75px', paddingBottom: '50px'}}>
                               <SearchBoxComponent  cssStyle={this.searchCSSStyle} searchKey={''} onSearchBoxButtonClicked={this.onSearchButtonClick} context={props.context}/>
                           </div>
                       </div>     */}
                       <>
                            <div id="home-nametune-web">
                                {
                                    this.getWebNameTune(state,props)
                                }
                            </div>
                            <div id="home-nametune-mobile">
                                {
                                    this.getMobileNameTune(state,props)
                                }
                            </div>
                       </>
                       
            </>
        );
    }

    getMobileNameTune(state:HomeComponentState,props:HomeComponentProps):JSX.Element
    {
        return(
            <>
                  <div id={this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?"home-nametune-english":"home-nametune-burmese"} style={{width:'100%', height:'140px',justifyContent:"center", marginTop:'0px',display: "flex", flexFlow: "row wrap",backgroundColor:this.getContext().getResources().getColor(Colors.color_42),backgroundSize: "cover",}}>
                           
                           <label style={{width:'100%',paddingLeft:'0px',paddingTop:'30px', height:'30px', lineHeight:'22px',fontSize:'16px',color:this.getContext().getResources().getColor(Colors.color_5),textAlign:'center'}}>
                               {this.getContext().getResources().getString(Strings.greet_caller_with_your_name_tunes)}
                           </label>
                           <div style={{marginTop:'0px',width:'80%',height:'40px',marginLeft:'0px', paddingBottom: '30px'}}>
                               <SearchBoxComponent  cssStyle={this.searchCSSStyle} searchKey={''} onSearchBoxButtonClicked={this.onSearchButtonClick} context={props.context}/>
                           </div>
                       </div> 
                 <div id={this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?"home-subscription-details-english":"home-subscription-details-burmese"} style={{width:'100%', height:'197px',flexFlow: "row wrap",backgroundColor: "#FFCB08",backgroundSize: "cover"}}>
                              <div style={{width:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? '100%' : "100%",height:'18px',fontWeight:'bold',marginLeft:'26px',marginRight: "0px", marginBottom:'20px', fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? '16px' : "14px",textAlign:'left',color:'#000000'}}>
                                       {state.subscriptionPlanDetailsDto.getTitle()}
                              </div>
                              <div style={{width:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? '100%' : "100%",height:'95px',marginLeft:'3px',marginBottom:'30px', fontSize:'14px',textAlign:'left',color:'#000000'}}>
                              <ul> 
                                { state.subscriptionPlanDetailsDto.getDescriptionList().map((data: string, index: number) =>
                                   {
                                       return <li  style={{width:'100%',lineHeight:'20px',letterSpacing:"-0.2px", fontSize:'13px',textAlign:'left'}} key={index}>{data}</li>;
                                   })
                                }
                                    
                              </ul>
                                           {/* <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Caller will listen to a musical ring back tone that you sent."}</li>
                                           <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Monthly subscription fee 300 Kyats"}</li>
                                           <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Subscription will be auto renewed after 30 days. "}</li>
                                           <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Tune price is 100 Kyats and each Tune is valid for 30 days. "}</li>
                                       </ul> */}
                              </div>
                       </div>  
            </>
        );
    }
    getWebNameTune(state:HomeComponentState,props:HomeComponentProps):JSX.Element{
        return(
            <>
                  <div  style={{width:'100%', height:'300px',marginTop:'25px',display: "flex", flexFlow: "row wrap", backgroundColor:this.getContext().getResources().getColor(Colors.color_42),backgroundSize: "cover",}}>
                  {/* ,backgroundImage: "url('" + this.getContext().getResources().getImage("nametunes.jpg") + "')", */}
                           <label  style={{width:'100%',paddingLeft:'75px',paddingTop:'80px', height:'30px', lineHeight:'30px',fontSize:'40px',color:this.getContext().getResources().getColor(Colors.color_5),textAlign:'left'}}>
                               {this.getContext().getResources().getString(Strings.greet_caller_with_your_name_tunes)}
                           </label>
                           <div id="search-box-main-div" style={{marginTop:'0px',width:'60%',height:'50px',marginLeft:'75px', paddingBottom: '50px'}}>
                               <SearchBoxComponent  cssStyle={this.searchCSSStyle} searchKey={''} onSearchBoxButtonClicked={this.onSearchButtonClick} context={props.context}/>
                           </div>
                       </div>    
                <div style={{width:'100%',paddingTop:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? '74px' : "94px", height:'350px',flexFlow: "row wrap",backgroundImage: "url('" + this.getContext().getResources().getImage("expressyourself.svg") + "')",backgroundSize: "cover"}}>
                              <div style={{width:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? '603px' : "755px",height:'55px',fontWeight:'bold',marginLeft:'auto',marginRight: "70px", marginBottom:'15px', fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? '40px' : "35px",textAlign:'left',color:'#000000'}}>
                                       {state.subscriptionPlanDetailsDto.getTitle()}
                              </div>
                              <div style={{width:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? '690px' : "840px",height:'132px',marginLeft:'auto',marginBottom:'74px', fontSize:'40px',textAlign:'left',color:'#000000'}}>
                              <ul> 
                                { state.subscriptionPlanDetailsDto.getDescriptionList().map((data: string, index: number) =>
                                   {
                                       return <li  style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}} key={index}>{data}</li>;
                                   })
                                }
                                    
                              </ul>
                                           {/* <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Caller will listen to a musical ring back tone that you sent."}</li>
                                           <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Monthly subscription fee 300 Kyats"}</li>
                                           <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Subscription will be auto renewed after 30 days. "}</li>
                                           <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Tune price is 100 Kyats and each Tune is valid for 30 days. "}</li>
                                       </ul> */}
                              </div>
                       </div>  
            </>
        );
    }
  
    getMPTBannerMobile(cssStyle:HomeCSSStyle):JSX.Element{
        return(
            <>
                {this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ?<img style={cssStyle.getMobileLogoCSSStyle()} src={this.getUIProps().context.getResources().getImage("tunisia_banner.svg")}/>
                :<img style={cssStyle.getMobileLogoCSSStyle()} src={this.getUIProps().context.getResources().getImage("tunisia_arabic_banner.svg")}/>}
             </>
        );
    }
    getMPTBannerWeb(cssStyle:HomeCSSStyle):JSX.Element{
        return(
            <>
                 {this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ?<img  style={cssStyle.getLogoCSSStyle()} src={this.getUIProps().context.getResources().getImage("tunisia_banner.svg")}/>
                 :<img style={cssStyle.getMobileLogoCSSStyle()} src={this.getUIProps().context.getResources().getImage("tunisia_arabic_banner.svg")}/>}
            </>
        );
    }
    getMobileView(props: HomeComponentProps, state: HomeComponentState, cssStyle: HomeCSSStyle):JSX.Element
    {
        return(
            <>
                    <img style={cssStyle.getMobileLogoCSSStyle()} src={this.getUIProps().context.getResources().getImage("tunisia_banner.svg")}/>
                       
                       {
                           state.isConfiguartionLoaded && state.listOfBannerDtos.length > 0 && 
                            <BannerComponent onBannerClick={this.onBannerClick} listOfBannerDto={state.listOfBannerDtos} context={props.context}/>
                       }
                       <div style={{width:'100%', height:'100px',justifyContent:'center',alignItems:'center',display:'flex', marginTop:'25px',flexFlow: "row wrap",backgroundImage: "url('" + this.getContext().getResources().getImage("search_bg.svg") + "')",backgroundSize: "cover",}}>
                       <div style={{paddingLeft:'40px',paddingRight:"40px",width: "100%", height:'40px'}}>
   
                               <SearchBoxToneOptionComponent type={props.context.getResources().getString(Strings.song)} context={this.getContext()} searchKey={""} onSearchBoxButtonClicked={this.onSpecificSearchClick}/>
                           </div>
                      </div>    
                      {state.isConfiguartionLoaded && 
                       <div id="" style={cssStyle.getInnerCSSStyle()}>
                            <FeaturedCategoryComponent context={props.context}/>
                       </div>
                      }
                       <div style={{width:'100%', height:'140px',justifyContent:"center", marginTop:'0px',display: "flex", flexFlow: "row wrap",backgroundColor:"#003187",backgroundSize: "cover",}}>
                           
                           <label style={{width:'100%',paddingLeft:'0px',paddingTop:'30px', height:'30px', lineHeight:'22px',fontSize:'16px',color:'#FFCD00',textAlign:'center'}}>
                               {this.getContext().getResources().getString(Strings.greet_caller_with_your_name_tunes)}
                           </label>
                           <div style={{marginTop:'0px',width:'80%',height:'40px',marginLeft:'0px', paddingBottom: '30px'}}>
                               <SearchBoxComponent  cssStyle={this.searchCSSStyle} searchKey={''} onSearchBoxButtonClicked={this.onSearchButtonClick} context={props.context}/>
                           </div>
                       </div>    
                       <div style={{width:'100%',paddingTop:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? '30px' : "30px", height:'197px',flexFlow: "row wrap",backgroundColor: "#FFCB08",backgroundSize: "cover"}}>
                              <div style={{width:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? '100%' : "100%",height:'18px',fontWeight:'bold',marginLeft:'26px',marginRight: "0px", marginBottom:'20px', fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? '16px' : "14px",textAlign:'left',color:'#000000'}}>
                                       {state.subscriptionPlanDetailsDto.getTitle()}
                              </div>
                              <div style={{width:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? '100%' : "100%",height:'95px',marginLeft:'3px',marginBottom:'30px', fontSize:'14px',textAlign:'left',color:'#000000'}}>
                              <ul> 
                                { state.subscriptionPlanDetailsDto.getDescriptionList().map((data: string, index: number) =>
                                   {
                                       return <li  style={{width:'100%',lineHeight:'20px',letterSpacing:"-0.2px", fontSize:'13px',textAlign:'left'}} key={index}>{data}</li>;
                                   })
                                }
                                    
                              </ul>
                                           {/* <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Caller will listen to a musical ring back tone that you sent."}</li>
                                           <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Monthly subscription fee 300 Kyats"}</li>
                                           <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Subscription will be auto renewed after 30 days. "}</li>
                                           <li style={{width:'100%',lineHeight:'33px',fontSize:'24px',textAlign:'left'}}>{"Tune price is 100 Kyats and each Tune is valid for 30 days. "}</li>
                                       </ul> */}
                              </div>
                       </div>  
            </>
        );
    }

    onSpecificSearchClick(searchKey:string, type:string):void
    {
        searchKey = searchKey.trim();
        (this.getUIComponentHandler() as HomeComponentHandler).onSpecificSearchClick(searchKey,type);

    }
    onSearchButtonClick(searchKey: string):void
    {
        searchKey = searchKey.trim();
        (this.getUIComponentHandler() as HomeComponentHandler).onSearchClick(searchKey);
    }
   getNavigationPath(): string[]
   {
      return [this.getUIProps().context.getResources().getString(Strings.home)];
   }

   

    // setLoadMoreData(title: string, listOfDatas: ToneDto[])
    // {
    //     let featuredCategoryComponent = this.featuredCategroiesRefMap.get(title);

    //     if(featuredCategoryComponent !== undefined)
    //     {
    //         featuredCategoryComponent.setLoadMoreData(listOfDatas);
    //     }
    // }

    private onBannerClick(bannerDto: BannerDto)
    {
        (this.getUIProps() as HomeComponentProps).onBannerClick(bannerDto);
    }

    private onLoadMore(featuredCategory: FeaturedCategoryDto, startIndex: number, offset: number): void
    {
        (this.getUIComponentHandler() as HomeComponentHandler)
                               .loadMoreFeaturedCategoryTones(featuredCategory, startIndex, offset);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/home/homeview.tsx